import {usePost} from "@hooks/http.ts";
import {useCallback} from "react";


export type CheckInResponse = {
    points?: number
};

type CheckInAction = (abortController?: AbortController) => void
export const useCheckIn = (): [
        CheckInResponse | undefined,
    boolean,
        Error | undefined,
    CheckInAction
] => {
    const [response, loading, error, post] = usePost<CheckInResponse>()
    const fn = useCallback(async (abortController?: AbortController) =>
        post(`/v1/check-in`, {}, abortController), [post]
    )
    return [response, loading, error, fn] as const;
}

